module.exports = __webpack_public_path__ + "static/brain-image-b581b7e1b8daf6881a200c0ee9f9dbc7.png";